module.exports = __webpack_public_path__ + "91df9ad6d5e48563743767547149ddce.png";